import React from 'react';
import { LeftMenuItem } from '../shared/LeftMenuItem';
import { marketplaceFlagCodes } from '../../../../notifications/notification-flag-codes';
import { ShowFirstThenFullTextOnHoverLabel } from '../../../ShowFirstThenFullTextOnHoverLabel/ShowFirstThenFullTextOnHoverLabel';
import { paths } from '../../../../routing/path';

export interface EngagementMenuItemProps {
    engagement: any;
}

export const EngagementMenuItem = (props: EngagementMenuItemProps) => {
    const { engagement } = props;
    let label: React.ReactNode = engagement.practiceNames[0];
    if (engagement.practiceNames.length > 1) {
        label = (
            <ShowFirstThenFullTextOnHoverLabel
                items={engagement.practiceNames}
            />
        );
    }

    return (
        <div className="flex-container">
            <LeftMenuItem
                icon="pe-7s-plugin"
                label={label}
                to={paths.venues.connect.engagement(engagement.id)}
                flagCode={marketplaceFlagCodes.sellerEngagement(engagement.id)}
                className={
                    engagement.practiceNames.length
                        ? 'vertical-nav-menu'
                        : 'vertical-nav-menu custom'
                }
                marginLeft={-15}
                stateIcon="pe-7s-plugin"
                trackingAction={engagement.practiceNames.join(', ')}
                forceReload
            />
        </div>
    );
};
